import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';
import { Utility } from '../../../common/utility';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA, MdOptionSelectionChange } from '@angular/material';
import { MomentModule } from 'angular2-moment';
import { AppConstants } from '../../../shared/constants/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormControl } from '@angular/forms';
import { LabTestsService } from '../../consultation-process/lab-tests/lab-tests.service';
import { ConsultationProcessService } from '../../consultation-process/consultation-process.service';
import { LabTestDataModel } from '../../../models/master-data/lab-test-data.model';

@Component({
    templateUrl: 'lab-test-popup.component.html',
    providers: [LabTestsService, ConsultationProcessService],
    styles: [
        `md-spinner {
      width: 24px;
      height: 24px;
      margin: 5px 10px 0px 0px;
      top: 0;
      right: 0;
      position: absolute;
    }`,
        `.form-group {
      width: 100%;
    }`,
        `.form-select, .mat-option{
      font-size: 14px
    }`
    ]
})

export class LabTestPopupComponent implements OnInit {
    public klass = 'labTests';
    public categorySelected: any = null;
    public categories: Array<any> = [];
    public labTests: Array<any> = [];
    public labTestToAdd: Array<any> = [];
    public labTestSelected: Array<any> = [];
    public labTestToRemove: Array<any> = [];
    public consultationId = '';
    public patientId = '';
    selectedSearchLabtest: any;
    searchList: Array<any>;
    quickSearchCtrl: FormControl;
    isSearching = false;
    height: string;
    constructor(public dialogService: DialogService,
        public consultationProcessService: ConsultationProcessService,
        public router: Router,
        public activeRouter: ActivatedRoute,
        public utility: Utility,
        public labTestsService: LabTestsService,
        public dialogRef: MdDialogRef<LabTestPopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: {
            patientId: string,
            consultationHistoryId: string,
            height: number
        }) {
        this.quickSearchCtrl = new FormControl();
        this.quickSearchCtrl.valueChanges.subscribe(keyword => {
            if (keyword) {
                if (keyword.length > 2) {
                    if (this.isSearching) { return; }
                    this.isSearching = true;
                    this.labTestsService.quickSearchLabTest(keyword, false).subscribe(result => {
                        this.isSearching = false;
                        if (result) {
                            const data = result.json();
                            const tempArr = <Array<LabTestDataModel>>data;
                            this.searchList = [];
                            if (this.labTestSelected) {
                                let i = 0;
                                const lens = tempArr.length;
                                while (i < lens) {
                                    const index = this.labTestSelected.findIndex(x => x.labTestCategoryId === tempArr[i].labTestCategoryId
                                        && x.centreLabtestId === tempArr[i].centreLabtestId);
                                    if (index < 0) {
                                        this.searchList = this.searchList.concat(tempArr[i]);
                                    }
                                    i++;
                                }
                            } else {
                                this.searchList = tempArr;
                            }
                        }
                    }, error => { this.isSearching = false; });
                }
            }
        });
    }

    ngOnInit() {
        if (this.activeRouter.snapshot.queryParams['labTestSelected']) {
            this.labTestSelected = this.activeRouter.snapshot.queryParams['labTestSelected'];
        }
        this.height = this.data.height ? (
            (this.data.height > 599 ?
                ((this.data.height - (this.data.height * 40 / 100)).toString() + 'px')  :
            (this.data.height - (this.data.height * 50 / 100)).toString() + 'px')
        ) : 'inherit';
        this.labTestsService.getConsultationLabTests(this.data.consultationHistoryId).subscribe(
            (result) => {
                if (result) {
                    this.labTestSelected = result.json();
                    this.labTestsService.getLabTestsCategories().subscribe(
                        (res) => {
                            if (res) {
                                const data = res.json();
                                this.categories = data;
                                this.categorySelected = this.categories[
                                    this.categories.findIndex(item => item.isSelected === true)] || this.categories[0];
                                this.getLabTest();
                            }
                        }
                    );
                }
            }
        );

    }

    //  Filter test related to selected category
    getLabTest() {
        if (this.categorySelected) {
            this.labTestsService.getLabTests(this.categorySelected.id).subscribe(
                (result) => {
                    if (result) {
                        const data = result.json();
                        this.labTests = data;
                        if (this.labTestToAdd.length > 0) {
                            this.labTestToAdd.forEach(pre => {
                                const index = this.labTests.findIndex(x => x.centreLabtestId === pre.centreLabtestId);
                                if (index > -1) {
                                    this.labTests[index]['checked'] = true;
                                }
                            });
                        }
                        this.checkLabTestsCategory();
                    }
                }
            );

        }

    }

    checkLabTestsCategory() {
        this.labTestSelected.forEach(labTest => {
            if (this.labTests.findIndex(item => item.centreLabtestId === labTest.centreLabtestId) >= 0) {
                this.labTests.splice(this.labTests.findIndex(item => item.centreLabtestId === labTest.centreLabtestId), 1);
            }
        });
    }

    // behavior when click button add
    selectLabTest() {
        this.labTestToAdd.forEach(item => {
            this.labTestSelected.push(item);
        });
        this.resetLabTestToAdd();
    }

    // behavior when click button remove
    removeLabTest() {
        this.labTestToRemove.forEach(item => {
            this.labTestSelected.splice(this.labTestSelected.findIndex(labTest => labTest.centreLabtestId === item.centreLabtestId), 1);
        });
        this.resetLabTestToRemove();
        this.getLabTest();
    }

    // checking if button add can be activated
    onCheckButtonAdd() {
        if (this.labTestToAdd.length < 1) {
            return true;
        }
        return false;
    }

    // checking if button remove can be activated
    onCheckButtonRemove() {
        if (this.labTestToRemove.length < 1) {
            return true;
        }
        return false;
    }

    // reset temp array for tests to add
    resetLabTestToAdd() {
        this.getLabTest();
        this.labTestToAdd = [];
    }

    // reset temp array for tests to remove
    resetLabTestToRemove() {
        this.labTestToRemove = [];
    }

    // create temp array for tests to add
    onCheckAddList(event, labtest) {
        const index = this.labTestToAdd.findIndex(item => item.centreLabtestId === labtest.centreLabtestId);
        labtest['checked'] = event.checked;
        if (event.checked && index === -1) {
            this.labTestToAdd.push(labtest);
        } else if (index >= 0) {
            this.labTestToAdd.splice(index, 1);
        }
        this.onCheckButtonAdd();
    }

    // create temp array for test to remove
    onCheckRemoveList(event, labtest) {
        const index = this.labTestToRemove.findIndex(item => item.centreLabtestId === labtest.centreLabtestId);
        if (event.checked && index === -1) {
            this.labTestToRemove.push(labtest);
        } else if (index >= 0) {
            this.labTestToRemove.splice(index, 1);
        }
        this.onCheckButtonRemove();
    }

    updateLabTestOrder() {
        for (let i = 0; i < this.labTestSelected.length; i++) {
            this.labTestSelected[i].order = i;
        }
    }

    /**
    * over write in base consultation submit consultation step data
    */
    submitData() {
        this.updateLabTestOrder();
        this.labTestsService.updateConsultationLabTests(this.data.consultationHistoryId, this.labTestSelected, false,true).subscribe(
            (result) => {
                if (result) {
                    // call API success
                    this.onCloseDialog(true);
                }
            }
        );
    }

    addLabTestFromSearch(event: MdOptionSelectionChange, labtest: any) {
        if (labtest) {
            const index = this.labTestSelected.findIndex(x => x.centreLabtestId === labtest.centreLabtestId);
            if (this.labTestToAdd.length > 0) {
                const temp = this.labTestToAdd.findIndex(x => x.centreLabtestId === labtest.centreLabtestId);
                if (temp > -1) {
                    this.labTestToAdd.splice(temp, 1);
                }
            }
            if (index < 0) {
                this.labTestSelected.push(labtest);
                this.getLabTest();
            }
            event.source.value = '';
            this.searchList = [];
        }
    }

    onCloseDialog(isSuccess = false) {
        this.dialogRef.close(isSuccess);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/lab-test/lab-test-popup.component.ts